import React, { createContext, useContext, useEffect, useState } from "react";
import { ensureSession, getMe } from "@/api";

const AuthCtx = createContext({ user: null, refresh: () => {}, loading: true });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const me = await getMe();
      setUser(me);
    } catch (e) {
      setUser(null);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        await ensureSession();
        const me = await getMe();
        setUser(me);
      } catch (e) {
        // Token might be stale -- start a fresh anonymous session
        try {
          localStorage.removeItem("axiom_token");
          localStorage.removeItem("axiom_codename");
          await ensureSession();
          const me = await getMe();
          setUser(me);
        } catch {
          /* swallow */
        }
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <AuthCtx.Provider value={{ user, refresh, loading }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
